import React from "react";
import { Helmet } from "react-helmet";
// import classes from "./EditInvoices.module.scss";

const REIInvoices = () => {
  return (
    <>
      <Helmet>
        <title>Received Invoices | DDD Invoices</title>
      </Helmet>
      <div className="w-100 h-100">
        <iframe
          src="@einvrei?header=false"
          frameBorder="0"
          title="edit-invoices-layout"
          style={{ width: "100%", height: "100%" }}
        ></iframe>
      </div>
    </>
  );
};

export default REIInvoices;
